import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_PLUS: GlameraIconDefinition = {
  name: 'user-plus',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-user-plus-body" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle class="glm-user-plus-head" cx="9" cy="7" r="4"></circle>
    <g class="glm-user-plus-sign">
      <line class="glm-user-plus-sign-line" x1="19" x2="19" y1="8" y2="14"></line>
      <line class="glm-user-plus-sign-line" x1="22" x2="16" y1="11" y2="11"></line>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-plus-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-plus.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserPlusIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_PLUS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
